export default function SlotMachine(canvas, spinButton, data, aspect, doneFunction) {

    let conf = {
        fps: 60,
        img: [],
        width: 420 + 20,
        height: 240,
        canvas: canvas,
        spinBtn: spinButton,
        mode: 'fixed',
        reel: {
            width: 141, height: 121, xOffsets: [0, 141, 282].map(x => x + 10), animTimes: [20, 25, 30].map(x => x * 100)
        },
        pSkip: 40,
        imgMap: [],
        imgStartPts: [...range(-2, 2)],
        imgDot: null,
        autoModeDelay: 3000,
        // sound: {
        //     win: new Audio('/assets/slotmachine/win.mp3'), spin: new Audio('/assets/slotmachine/spin.mp3')
        // },
        aspect: aspect,
        done: doneFunction,
        background: data.slotBackgroundColor
    };

    data.items.forEach((i, j) => {
        conf.imgMap.push(i.identifier);
        let img = new Image();
        img.addEventListener('load', function () {
            conf.img[i.identifier] = img;
        });
        img.src = i.imageUrl;
    })

    //sounds load
    // conf.sound.win.load();
    // conf.sound.spin.load();

    //instantiation the game
    let slot = new Slot(conf.canvas.getContext('2d'), conf, data.startScenario, data.scenario);
    let fps = conf.fps;
    let interval = 1000 / fps;
    let delta;
    let lastpUpdate = 0;

    setTimeout(function() {
        slot.start();
    }, 500);


    function update(now) {
        delta = now - lastpUpdate;
        if (delta > interval) {
            lastpUpdate = now - (delta % interval);
            slot.loop(now);
        }
        window.requestAnimationFrame(update);
    }

    window.requestAnimationFrame(update);

    return slot;
}

/**
 * Create sequence generator from to
 */

function* range(start, end) {
    for (let i = start; i <= end; i++) {
        yield i;
    }
}


//reel.js
const Reel = function (canvas, conf, scenario, offsetX = 0) {

    //generate img objects for a reel
    this.reelMap = conf.imgMap.shuffle()
        .map((text, index) => ({
            offsetY: conf.reel.height * conf.imgStartPts[index], key: text
        }));

    this.fnc = null;
    this.spinning = false;
    this.finalAnimation = false;
    this.clickTime = 0;
    this.showedLastAnim = false;
    this.clicked = false;
    this.mode = 'fixed';
    this.fixedPlace = 'middle';
    this.fixedImg = scenario;
    this.finalShapes = [];
    //clear whole reel
    const clear = function () {
        canvas.clearRect(offsetX, conf.height, conf.reel.width, conf.height);
    };


    //draw image to specific point
    const draw = function (key = 'BAR', offsetY = 0, blur = 0) {
        if (conf.img.hasOwnProperty(key)) {
            clear();
            canvas.strokeStyle = conf.background;
            //   canvas.filter = `blur(${blur}px)`;
            canvas.lineWidth = 4;
            canvas.fillRect(offsetX, offsetY, conf.reel.width, conf.reel.height);
            canvas.strokeRect(offsetX, offsetY, conf.reel.width, conf.reel.height);
            canvas.drawImage(conf.img[key], offsetX, offsetY, 141, 121);
            //   canvas.filter = 'none';
        }
    };

    this.spinAnimation = function (skip) {
        if (!this.spinning) return;

        this.reelMap.forEach(img => {

            img.offsetY += conf.pSkip;
            //reset prev and jump very top
            if (img.offsetY >= conf.height) {
                img.offsetY = conf.reel.height * -3;
            }

            //draw img object
            draw(img.key, img.offsetY, 4);
        });
    };

    this.generateReelShapesFixed = function () {
        let imgMp = conf.imgMap.filter(x => x !== this.fixedImg);
        let rndImg2 = imgMp.rnd();
        imgMp.splice(imgMp.indexOf(rndImg2), 1);
        let rndImg3 = imgMp.rnd();

        return [{
            offsetY: -120, key: rndImg2, stop: -60
        }, {
            offsetY: 0, key: this.fixedImg, stop: 60
        }, {
            offsetY: 120, key: rndImg3, stop: 180
        }];
    };

    this.setFinalShapes = function () {
        return this.generateReelShapesFixed();
    };

    this.spin2point = function () {
        if (!this.finalAnimation) {
            if (typeof this.fnc === 'function') {
                this.fnc();
                this.fnc = null;
            }
            return;
        }

        let stopPt;
        this.finalShapes.forEach(img => {
            if (img.hasOwnProperty('stop')) {
                stopPt = img.stop;
            }
            let inx = 6;
            if (img.offsetY + inx === stopPt) {
                this.finalAnimation = false;
            }
            img.offsetY += inx;

            //draw img object
            draw(img.key, img.offsetY);
        });
    };

    this.done = function (fn) {
        this.fnc = fn;
    }

};


//slot.js

const Slot = function (canvas, conf, startScenario, scenario) {

    canvas.scale(conf.aspect.ratio, conf.aspect.ratio);
    // Set the background color
    canvas.fillStyle = conf.background;
    canvas.fillRect(0, 0, canvas.width, canvas.height);



    this.canvas = canvas;
    let auto = false;
    let reels = [...range(1, 3)]
        .map(i => new Reel(canvas, conf, startScenario[i - 1], conf.reel.xOffsets[i - 1]));

    let delta = 0;
    let currentSpin = [];

    this.spin = function () {
        //conf.sound.spin.play();

        for (let i = 0; i < 3; i++) {
            reels[i].fixedImg = scenario[i];
        }

        currentSpin = [];
        reels.forEach(reel => {
            reel.clicked = true;
            reel.finalAnimation = false;
            reel.finalShapes = reel.setFinalShapes();
            currentSpin.push(reel.finalShapes);
        });
    };

    this.setMode = function () {
        reels.forEach(reel => {
            reel.mode = conf.mode.value;
        });
    };

    this.loop = function (now) {
        reels.forEach((reel, i) => {
            //init spin animation
            reel.spinAnimation();
            reel.spin2point();

            if (reel.clicked) {
                reel.clicked = false;
                reel.clickTime = now;
                reel.spinning = true;
            }

            delta = now - reel.clickTime;
            if (delta > conf.reel.animTimes[i] && reel.spinning) {
                reel.finalAnimation = true;
                reel.spinning = false;

                if (i === 2) {
                    reel.done(() => {
                        conf.done();
                        //reset sound and stop
                        // conf.sound.spin.currentTime = 0;
                        // conf.sound.spin.pause();
                    });
                }
            }
        });
    };

    this.start = function () {
        // conf.sound.win.volume = 1.0;
        // conf.sound.spin.volume = 0.03;
        reels.forEach(reel => {
            reel.clicked = true;
            reel.finalAnimation = false;
            reel.finalShapes = reel.setFinalShapes();
        });
        reels.forEach((reel, i) => {
            reel.clicked = false;
            reel.finalAnimation = true;
            reel.spinning = false;
        });
        return this;
    };

    let check = function (reels) {
        return false;
    };

};

/**
 * Array prototype
 * Shuffles array in place.
 */
Array.prototype.shuffle = function () {
    for (let i = this.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this[i], this[j]] = [this[j], this[i]];
    }
    return this;
};

//get random element
Array.prototype.rnd = function () {
    return this[Math.floor(Math.random() * this.length)];
};